import { infoService, vueTagService, tagLookupService } from '@/angularBridgeCode/ringbaPortal.servicesModule';



import {
  GET_COUNTRIES, GET_TAGS, GET_MACROS
} from './actionTypes';

import { SET_COUNTRIES, SET_TAGS, SET_MACROS } from './mutationTypes';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_ERROR, SET_ACTION_STATUS_SUCCESS } from '@/store/helpers';

const actions = {
  async [GET_COUNTRIES]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: GET_COUNTRIES });
    try {
      const {data: countries } = await infoService.getCountries();
      commit(SET_COUNTRIES, countries);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_COUNTRIES });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_COUNTRIES, error: e });
    }
  },

  async [GET_TAGS]({ commit, rootState }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: GET_TAGS });
    try {
      const { data: tags } = await vueTagService.getTags(rootState.currentAccountId);

      tags.sort((a, b) => {
        const { tagName: _a } = a;
        const { tagName: _b } = b;
        
        if (_a < _b) {
          return -1;
        } else if (_a > _b) {
          return  1;
        } else {
          return 0;
        }
      });
      
      commit(SET_TAGS, tags);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_TAGS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_TAGS, error: e });
    }
  },

  async [GET_MACROS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: GET_MACROS });
    try {
      const response = await tagLookupService.getTagMacros(rootState.currentAccountId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_MACROS });
      commit(SET_MACROS, response.data.macros);
    } catch (e) {
      commit(SET_MACROS, {});
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_MACROS, error: e });
    }
  },
  
};

export default actions;